/* globals console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    //
    TheMap = require('./map'), // 'The Map' because Map is a reserved word...
    configuration = require('../utilities/configuration.json'),
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'programs-map'
    },
    childViewEvents: {
        'click:marker':              'onClickMarker',
        //
        'latitudeLongitude:updated': 'onLatitudeLongitudeUpdated'
    },
    regions: {
        mapContent:  {el: 'div[name=mapContent]',  replaceElement: true}
    },
    tagName: 'div',
    template: templates.programsMap,
    ui: {
        form: 'form[name=programsMap]'
    },
    //
    initialize: function () {
        this.listenTo(this.collection, 'reset update change', _.bind(function () {
            this.addMarkers();
        }, this));
        if (this.collection.length) {
            this.addMarkers();
        }
    },
    latitudeLongitude: function (latitudeLongitude) {
        this.getChildView('mapContent').geolocation(latitudeLongitude.latitude, latitudeLongitude.longitude);
    },
    onClickMarker: function (payload) {
        this.trigger('select:programId', payload.id);
    },
    onLatitudeLongitudeUpdated: function (latitudeLongitude) {
        latitudeLongitude.source = 'programsMap';
        this.trigger('latitudeLongitude:updated', latitudeLongitude);
    },
    onRender: function () {
        this.showChildView('mapContent', new TheMap({via: this.cid}));
        // console.log('programsMap.onRender - showChildView mapContent (%s)', this.cid);
    },
    addMarkers: function () {
        // @acavan! - can this be made smarter? compare marker ids with collection ids and only run if they differ?
        // console.log('programsMap.addMarkers (%s)', this.cid);
        const mapContent = this.getChildView('mapContent');
        let count = 0;
        mapContent.clearMarkers();
        _.each(this.collection.models, _.bind(function (model) {
            if (model.get('latitudeCache') && !model.hidden) {
                mapContent.addMarker(model.get('latitudeCache'), model.get('longitudeCache'), {payload: {id: model.id}}, 'programsMap:' + this.cid);
                count++;
            }
        }, this));
        if (count) {
            mapContent.fitBounds();
        } else {
            mapContent.centerMap(configuration.geolocations[configuration.geolocation]);
        }
    },
    refreshMarkers: function () {
        // console.log('programsMap.refreshMarkers');
        this.addMarkers();
    }
});
